import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import GuildBanner from "./components/GuildBanner";

export default function HomePage() {
  return (
    <div className="bg-[#080808] min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <GuildBanner />
      <Footer />
    </div>
  );
}
